export default __webpack_public_path__ + "static/media/rtresonance.f3f4cd74.png";